import { Box, Typography, Alert, AppBar, Toolbar } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import techpinesBackground from '../../assets/techpines-background-transparent.png';
import VerificarRecibo from './VerificarRecibo';
import VerificarReceita from './VerificarReceita';

export default function VerificarAssinatura() {
    const [searchParams] = useSearchParams();
    const tipo = searchParams.get('tipo');

    if (tipo === 'recibo') {
        return <VerificarRecibo />;
    }

    if (tipo === 'receita') {
        return <VerificarReceita />;
    }

    // Se não tiver tipo ou tipo inválido, redireciona para login
    return (
        <Box display="flex" flexDirection="column" justifyContent="space-between" minHeight="100vh" textAlign="center">
            <AppBar position="static" color="primary">
                <Toolbar>
                    <Box sx={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
                        <img
                            src={techpinesBackground}
                            alt="Techpines Logo"
                            style={{ width: 200, height: 50, marginRight: 16 }}
                        />
                    </Box>
                </Toolbar>
            </AppBar>

            <Box maxWidth={600} margin="0 auto" padding={4}>
                <Alert severity="warning" icon={false}>
                    <Typography variant="h4" gutterBottom>
                        <span role="img" aria-label="warning">⚠️</span> Tipo de verificação não suportado
                    </Typography>
                    <Typography variant="body1">
                        O sistema não possui verificação para o tipo "{tipo || 'não informado'}".
                    </Typography>
                    <Typography variant="body2" color="textSecondary" mt={2}>
                        Tipos suportados: receita, recibo
                    </Typography>
                </Alert>
            </Box>

            <Box component="footer" bgcolor="primary.main" color="white" style={{ paddingTop: 10, paddingBottom: 10 }} textAlign="center">
                <Box display="flex" justifyContent="center" mb={1}>
                    <Box display="flex" alignItems="center" mr={3} style={{ marginTop: 0 }}>
                        <EmailIcon fontSize="small" style={{ marginRight: 4 }} />
                        <Typography variant="body2">
                            contato@techpines.com.br
                        </Typography>
                    </Box>
                    <Box display="flex" alignItems="center">
                        <InstagramIcon fontSize="small" style={{ marginRight: 4 }} />
                        <Typography variant="body2">
                            techpines
                        </Typography>
                    </Box>
                </Box>
                <Typography variant="body2" color="inherit" mt={1}>
                    &copy; 2024 Techpines. Todos os direitos reservados.
                </Typography>
            </Box>
        </Box>
    )
}
